import Service from '@ember/service';

import { tracked } from '@glimmer/tracking';

export default class FieldHeightOverlaysService extends Service {
  @tracked containerEl;
}
